/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type BvFlashService from 'volta/services/bv-flash';

interface BvFlashContainerSignature {
  Args: { position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' };
  Element: HTMLDivElement;
}

export default class BvFlashContainerComponent extends Component<BvFlashContainerSignature> {
  @service declare bvFlash: BvFlashService;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFlashContainer: typeof BvFlashContainerComponent;
    'bv-flash-container': typeof BvFlashContainerComponent;
  }
}
